import React, { useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import { TablePagination, Box } from '@mui/material';
import Paper from '@mui/material/Paper';
import TableListHead from '../../layouts/TableListHead';
import PartnerBody from './PartnerBody';
import EditPartner from './EditPartner';
import { useQuery } from 'react-query';
import axios from 'axios';
import { API_URL } from '../../../../links/API_LINKS';
import CircularProgress from '@mui/material/CircularProgress';

const fetchAllPartners = async (params) => {
  const { limit, page, sort, order } = params;
  const res = await axios.get(API_URL + '/partner', {
    params: {
      limit: limit || 0,
      sort: sort || 'name',
      order: order || 'asc',
      page: page || 0,
    },
  });
  return res;
};

function PartnerHeader() {
  const [partnerToEdit, setPartnerToEdit] = useState(null);

  const [paginationData, setPaginationData] = useState({
    page: 0,
    limit: 10,
    sort: 'name',
    order: 'asc',
  });

  const { status, data, isFetching } = useQuery(
    [`fetchAllPartners`, paginationData],
    () => fetchAllPartners({ ...paginationData }),
    { keepPreviousData: true }
  );

  const handleRequestSort = (event, property) => {
    const isAsc =
      paginationData.sort === property && paginationData.order === 'asc';
    setPaginationData({
      ...paginationData,
      sort: property,
      order: isAsc ? 'desc' : 'asc',
    });
  };

  const TABLE_HEAD = [
    { id: 'name', label: 'Name', align: 'left' },
    { id: 'country', label: 'Country', align: 'left' },
  ];

  const handleChangePage = (event, newPage) => {
    setPaginationData({
      ...paginationData,
      page: newPage,
    });
  };
  const handleChangeRowsPerPage = (event) => {
    setPaginationData({
      ...paginationData,
      page: 0,
      limit: event.target.value,
    });
  };

  return (
    <>
      {status === 'loading' && (
        <Box
          display='flex'
          justifyContent='center'
          alignItems='center'
          minHeight='50vh'
          minWidth='100vw'
        >
          <CircularProgress />
        </Box>
      )}
      {status === 'error' && <div>Error fetching data</div>}
      {status === 'success' && (
        <>
          {partnerToEdit ? (
            <EditPartner
              partnerToEdit={partnerToEdit}
              setPartnerToEdit={setPartnerToEdit}
            />
          ) : (
            <TableContainer component={Paper}>
              <Table
                sx={{ minWidth: 650, shadow: 2, padding: '6px' }}
                aria-label='table'
                size='small'
              >
                <TableListHead
                  order={paginationData.order}
                  orderBy={paginationData.sort}
                  headLabel={TABLE_HEAD}
                  onRequestSort={handleRequestSort}
                />
                <TableBody>
                  {data.data.data.map((row) => (
                    <PartnerBody
                      key={row._id}
                      row={row}
                      setPartnerToEdit={setPartnerToEdit}
                    />
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[
                  ...new Set([paginationData.limit, 5, 10, 50]),
                ]}
                component='div'
                count={data.data.totalCount}
                rowsPerPage={paginationData.limit}
                page={paginationData.page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                nextIconButtonProps={{
                  disabled:
                    isFetching || data.data.page === data.data.totalPages - 1,
                }}
              />
            </TableContainer>
          )}
        </>
      )}
    </>
  );
}

export default PartnerHeader;
